@if (shouldShowSizeSelector()) {
    <div class="choice-wrapper">
        <cwo-expandable-component (isExpanded)="handleExpansion($event)" [expandedInput]="expanded" [headerStyle]="'left'" [ariaControlsName]="'Size'" [style.--expand-duration]="'0.3s'">
            <ng-template #heading>
                <div class="header-wrapper">
                    <cwo-icon [name]="iconNameType.arrow" class="icon" [ngStyle]="{
                transform: expanded ? 'rotate(0deg)' : 'rotate(-90deg)'
                }" />
                    <span class="label">{{'shared_components.choices.sizes' | transloco}}</span>
                </div>
            </ng-template>
            <ng-template #content>
                @if(availableSizePrices().length > 3){
                <div class="column-content-wrapper">
                    <fieldset>
                        @for (size of availableSizePrices(); track $index) {
                            <label class="size-wrapper column">
                                <input class="themed-radio" type="radio" [name]="'size'" 
                                    [checked]="size.label === selectedSize?.label" 
                                    (change)="changeSize(size)"
                                    [attr.aria-label]="getSizeAriaLabel(size)"
                                    [attr.aria-checked]="size.label === selectedSize?.label">
                                <div class="info-container" aria-hidden="true">
                                    <span class="size">
                                        {{size.label}}
                                        @if(size?.servings) {
                                            <span class="servings">
                                                <span class="dot-separator"></span>
                                                <span class="servings-text">{{ orderableItemService.getServings(size) }}</span>
                                            </span>
                                        }
                                    </span>
                                    @if (size.caloriesFrom) {
                                    <span class="calories-sizes">{{calMessage(size)}}</span>
                                    }
                                    @if(!isSpecial() && selectedSize && size.label !== selectedSize.label && calculatePrice(size) ){
                                        <span class="price-difference">{{calculatePrice(size)}}</span>
                                    }
                                </div>
                            </label>
                            @if(hasNoticePeriod(size)){
                                <span class="notice-period" aria-hidden="true">{{calculatePrepTime(size.noticePeriod!)}}</span>
                            }
                        }
                    </fieldset>
                </div>
                } @else {
                <fieldset class="row-content-wrapper">
                    @for (size of availableSizePrices(); track $index) {
                        <label class="size-wrapper">
                            <input class="themed-radio" type="radio" [name]="'size'" 
                                [checked]="size.label === selectedSize?.label"
                                (change)="changeSize(size)"
                                [attr.aria-label]="getSizeAriaLabel(size)"
                                [attr.aria-checked]="size.label === selectedSize?.label">
                            <div class="info-container" aria-hidden="true">
                                <div [ngClass]="{'flex-row': hasNoticePeriod(size), 'flex-column': !hasNoticePeriod(size)}">
                                    <span class="size">
                                        {{size.label}}
                                        @if(size?.servings) {
                                            <span class="servings">
                                                <span class="dot-separator"></span>
                                                <span class="servings-text">{{ orderableItemService.getServings(size) }}</span>
                                            </span>
                                        }
                                    </span>
                                    @if(!isSpecial() && selectedSize && size.label !== selectedSize.label && calculatePrice(size) ){
                                        <span class="price-difference">{{calculatePrice(size)}}</span>
                                    }
                                </div>
                                @if(hasNoticePeriod(size)){
                                    <span class="notice-period">{{calculatePrepTime(size.noticePeriod!)}}</span>
                                }
                            </div>
                            @if (size.caloriesFrom) {
                                <hr class="divider" aria-hidden="true" />
                                <div class="calories-wrapper" aria-hidden="true">
                                    <span class="calories-sizes">{{calMessage(size)}}</span>
                                </div>
                            }
                        </label>
                    }
                </fieldset>
                }
            </ng-template>
        </cwo-expandable-component>
        @if(!expanded && selectedSize){
            <span class="selected-ingredients-label">{{selectedSize.size}}</span>
        }
        @if (shouldShowUnavailableMessage()) {
            <div class="unavailable-message">
                <cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>
                <span>{{ 'shared_components.choices.some_sizes_unavailable' | transloco }}</span>
            </div>
        }
    </div>
}
@if(filteredChoiceGroups.length) {
    @for (choiceGroup of filteredChoiceGroups; track $index) {
        @if(choiceGroup.choices.length === 1) { 
            <cwo-choice
            [name]="choiceGroup.name"
            [isSpecial]="isSpecial()"
            [expandedInput]="$index === 0"
            [choice]="choiceGroup.choices[0]"
            [dependableChoices]="dependableChoices"
            [orderedChoice]="orderedItem().getChoice(choiceGroup.choices[0].name)"
            [orderedItem]="orderedItem()"
            [orderableItem]="orderableItem()"
            [toggleWarningsAfterSubmission]="toggleWarningsAfterSubmission()"
            [firstInvalidChoice]="firstInvalidChoice()"
            (resetWarningsAfterSubmissionValue)="resetWarningsAfterSubmissionValue.emit()"
            (updateSpecialItem)="updatedSpecialItem.emit($event)"
            />
        } @else {
            <cwo-choice-group 
            [choices]="choiceGroup.choices"
            [name]="choiceGroup.name"
            [isSpecial]="isSpecial()"
            [expandedInput]="$index === 0"
            [dependableChoices]="dependableChoices"
            [orderedChoices]="getOrderedChoicesForGroup(choiceGroup.name)"
            [orderedItem]="orderedItem()"
            [orderableItem]="orderableItem()"
            [toggleWarningsAfterSubmission]="toggleWarningsAfterSubmission()"
            [firstInvalidChoice]="firstInvalidChoice()"
            (resetWarningsAfterSubmissionValue)="resetWarningsAfterSubmissionValue.emit()"
            (updateSpecialItem)="updatedSpecialItem.emit($event)"
            />
        }
    }
} @else {
    @for(choice of filteredChoices; track $index) {
        <cwo-choice 
            [isInChoiceGroup]="false"
            [isSpecial]="isSpecial()"
            [choice]="choice" 
            [dependableChoices]="dependableChoices"
            [orderedChoice]="orderedItem().getChoice(choice.name)" 
            [orderedItem]="orderedItem()"
            [orderableItem]="orderableItem()" 
            [toggleWarningsAfterSubmission]="toggleWarningsAfterSubmission()"
            [firstInvalidChoice]="firstInvalidChoice()"
            (resetWarningsAfterSubmissionValue)="resetWarningsAfterSubmissionValue.emit()"
            (updateSpecialItem)="updatedSpecialItem.emit($event)"
        />
    }
}